export function getFieldValue(field) {
  if (field == null || field === "") return "";
  if (typeof field === "object" && field.value != null) return field.value;
  if (Array.isArray(field)) return field.length ? field : "";
  return field;
}

export function isEmptyField(field) {
  const value = getFieldValue(field);
  return value === "" || value == null;
}

export function validatePipelineForm(fields, rules = []) {
  const errors = {};

  rules.forEach(({ column, label }) => {
    if (isEmptyField(fields[column])) {
      errors[column] = `${label} is required.`;
    }
  });

  return {
    valid: Object.keys(errors).length === 0,
    errors,
  };
}

export const CANDIDATE_PIPELINE_RULES = [
  { column: "candidate_firstname", label: "First name" },
  { column: "candidate_lastname", label: "Last name" },
  { column: "candidate_client_id", label: "Client" },
  { column: "candidate_requirement_id", label: "Requirement" },
  { column: "candidate_mobile", label: "Mobile" },
  { column: "candidate_email", label: "Email" },
  { column: "candidate_experience_total", label: "Total experience" },
  { column: "candidate_present_location", label: "Present location" },
  { column: "candidate_preffered_location", label: "Preferred location" },
  { column: "candidate_notice_period", label: "Notice period" },
  { column: "candidate_status_id", label: "Status" },
];

export const INTERVIEW_PIPELINE_RULES = [
  { column: "interview_candidate_id", label: "Candidate" },
  { column: "interview_client_id", label: "Client" },
  { column: "interview_requirement_id", label: "Requirement" },
  { column: "interview_round_id", label: "Round" },
  { column: "interview_date", label: "Date" },
  { column: "interview_time", label: "Time" },
  { column: "interview_mode", label: "Mode" },
  { column: "interview_status_id", label: "Status" },
];

export const ONBOARD_PIPELINE_RULES = [
  { column: "onboard_candidate_id", label: "Candidate" },
  { column: "onboard_client_id", label: "Client" },
  { column: "onboard_requirement_id", label: "Requirement" },
  { column: "onboard_total_exp", label: "Total experience" },
  { column: "onboard_relevant_exp", label: "Relevant experience" },
  { column: "onboard_present_location", label: "Present location" },
  { column: "onboard_offered_ctc", label: "Offered CTC" },
  { column: "onboard_expected_ctc", label: "Expected CTC" },
  { column: "onboard_doj", label: "Date of joining" },
  { column: "onboard_work_location", label: "Work location" },
];
